var $ = require('jquery');
var applicationUtils = require('./../applicationUtils');

$.i18n = require('jquery-i18n');

if (!window.skipI18nInitialization && !applicationUtils.currentApplication.skipI18nInitialization) {
  $.i18n.properties({
    name: [ applicationUtils.currentApplication.i18nBundle ],
    path: applicationUtils.currentApplication.staticMessagesPath,
    mode: 'map'
  });
}

module.exports = $.i18n;
